<template>
  <!-- //审批规则  -->
  <div class="approval-content">
    <div class="send-tip">
      订单由以下人审批
    </div>
    <div class="send-item send-title van-hairline--top">
      <div class="send-item-left title-left ">
        审批级别
      </div>
      <div class="send-item-right">
        审批人
      </div>
    </div>
    <div
      class="send-item van-hairline--top"
      v-for="(items,index1) in spDetail.gznr"
      :key="index1"
    >
      <div class="send-item-left ">
        <span>{{ items.level }}</span>
        <span v-show="items.empList[0].jblx==1">(仅确认)</span>
      </div>
      <div class="send-item-right ">
        <div
          style="line-height: normal;"
          v-for="(item,index2) in items.empList"
          :key="index2"
        >
          {{ item.empNo }}&nbsp;{{ item.empName }} ({{ item.vipdeptName }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'ApprovalRule',
  props: {
    spgzId: {
      type:String,
      default:''
    }
  },
  data () {
    return {
      spDetail:{}
    }
  },
  created () {
    this.getApprovaDetail()
  },
  methods: {
    //获取审批规则详情
    getApprovaDetail() {
      if(!this.spgzId) return
      this.$api['approval/vipSpgzGetInfo']({spgzId: this.spgzId}).then(res => {
        let cache=res.data||{}
        this.spDetail = cache
      }).catch(res =>{
        this.$toast(res.errMsg)
      })
    }
  },
}

</script>

<style lang="less" scoped>
.approval-content {
  padding: 15px;
	.approvalRule .mui-bar a {
		line-height: 44px;
		font-size: 32px;
	}
	.send-title,
	.send-tip {
		padding: 10px 0;
	}

	.send-item {
		width: 100% ;
		height: 50px;
		line-height: 50px;
		display: flex;
		align-items: center;
	}

	.send-item .send-item-left {
		width: 30%;
		text-align: center;
	}

	.send-item .title-left {
		text-align: left;
	}

	.send-item .send-item-right {
		width: 80%;
		text-align:left;
		padding-left: 10px;
		/*font-size: 0.9rem;*/
	}
}
</style>
